import React from 'react';
import Button from '../../common/Button/Button';
import styles from './FinalCTA.module.css';

function FinalCTA({ noMargin = false }) {
  const sectionClasses = `${styles.ctaSection} ${noMargin ? styles.noMargin : ''}`;

  return (
    <section className={sectionClasses}>
      <div className="container">
        <div className={styles.ctaCard}>
          <div className={styles.ctaContent}>
            <span className={styles.eyebrow}>Votre Futur Projet</span>
            <h2 className={styles.title}>Prêt à donner vie à votre projet ?</h2>
            <div className={styles.divider}></div>
            <p className={styles.description}>
              Contactez-nous dès aujourd'hui pour discuter de vos idées. Notre équipe est à votre écoute pour vous accompagner à chaque étape, de la conception à la livraison de votre maison en bois.
            </p>
            <div className={styles.ctaWrapper}>
              <Button to="/contact" variant="primary" size="large">Prendre rendez-vous</Button>
            </div>
          </div>
          <div className={styles.ctaDecoration}></div>
        </div>
      </div>
    </section>

  );
}

export default FinalCTA;
